module.exports = __webpack_public_path__ + "media/images/default/pages/homepage/questions/2-1cc261995decc45ed35b623918e032b4.svg";